import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchOne } from '../../../clinet';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Avatar, Button, Center, Flex, HStack, Text } from '@chakra-ui/react';
import moment from 'moment';
import Benifits from '../../../components/Benifits/Benifits';
import Loading from '../../../components/Loading';
import SeoAndOgTag from '../../../components/SeoAndOgTag';
import Socials2 from '../../../components/Socials2';
import { usePWAInstall } from 'react-use-pwa-install';

const Blog = () => {
  const { slug } = useParams();

  const [blog, setBlog] = useState({});
  // console.log(blog);
  const install = usePWAInstall();

  useEffect(() => {
    if (install) {
      install();
    }
  }, [install]);

  useEffect(() => {
    fetchOne('blog', slug)
      .then(res => {
        // console.log(res[0].fields);
        setBlog(res[0].fields);
      })
      .catch(err => {
        console.log(err);
      });
  }, [slug]);
  // console.log(blog);
  if (!blog) return <Loading />;
  return (
    <div>
      <SeoAndOgTag
        metaTitle={blog?.title}
        metaDescription={blog?.ogDescription}
        metaImage={blog?.heroImage?.fields?.file?.url}
        url={`/blog/${slug}`}
        keywords={blog?.keywords ? `${blog?.keywords.map(kw => kw)}` : ''}
      />
      <div className="text-center pt-16 md:pt-32">
        <p className="text-sm md:text-base text-green-500 font-bold">
          {moment(blog?.date).utc().format('DD-MM-YYYY')}
        </p>
        <h1 className="font-bold break-normal text-3xl md:text-5xl">
          {blog?.title}
        </h1>
      </div>
      <br />
      <Center>
        <img
          src={blog?.heroImage?.fields?.file?.url}
          alt={blog?.title}
          className="container w-full max-w-lg mx-auto   bg-white bg-cover mt-1 rounded "
        />
      </Center>
      <br />
      <Socials2 />
      <br />
      <Center>
        {install && (
          <Button
            onClick={install}
            colorScheme="blue"
            size="md"
            bgGradient="linear(to-l, #ae61fa, #fc77ba)"
            _hover={{ bgGradient: 'linear(to-l,  #fc77ba, #ae61fa)' }}
          >
            Add To Home Screen For More Knowledge
          </Button>
        )}
      </Center>
      <div className="container max-w-5xl mx-auto ">
        <div className="mx-0 sm:mx-6">
          <div
            className="bg-white w-full p-8 md:p-24 text-xl md:text-2xl text-gray-800 leading-normal"
            styles="font-family:Georgia,serif;"
          >
            <HStack spacing={3}>
              <Avatar
                size="md"
                name={blog?.auther}
                src={blog?.autherImage?.fields?.file?.url}
              />
              <Flex direction="column">
                <Text fontWeight="bold" fontSize="md">
                  {blog?.auther}
                </Text>
                {/* <Text fontWeight="light" fontSize="xs"></Text> */}
              </Flex>
            </HStack>
            <p className="text-2xl md:text-3xl mb-5">
              {documentToReactComponents(blog?.description)}
            </p>
          </div>
        </div>
      </div>
      <Center>
        {install && (
          <Button
            onClick={install}
            colorScheme="blue"
            size="md"
            bgGradient="linear(to-l, #ae61fa, #fc77ba)"
            _hover={{ bgGradient: 'linear(to-l,  #fc77ba, #ae61fa)' }}
          >
            Add To Home Screen For More Knowledge
          </Button>
        )}
      </Center>
      <div className="container px-6 py-16 mx-auto">
        {blog?.entries?.map((entry, i) => (
          <Benifits
            key={i}
            title={entry?.fields?.title}
            description={entry?.fields?.description}
            imageUrl={entry?.fields?.image?.fields?.file?.url}
            imageTitle={entry?.fields?.image?.fields?.title}
          />
        ))}
      </div>
      <Center>
        {install && (
          <Button
            onClick={install}
            colorScheme="blue"
            size="md"
            bgGradient="linear(to-l, #ae61fa, #fc77ba)"
            _hover={{ bgGradient: 'linear(to-l,  #fc77ba, #ae61fa)' }}
          >
            Add To Home Screen For More Knowledge
          </Button>
        )}
      </Center>
      <br />
    </div>
  );
};

export default Blog;
